import { Component, inject } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface HelpVideoPlayerData {
  titleKey: string;
  // Sanitized YouTube / Vimeo embed URL, already carrying autoplay=1
  embedUrl: SafeResourceUrl | null;
  fileUrl: string | null;
}

/**
 * Full-viewport player for a help video. Opened by HelpVideosComponent via MatDialog, which
 * also handles closing on Esc. Clicking the dimmed area around the player closes it too.
 */
@Component({
  selector: 'app-help-video-player-dialog',
  standalone: false,
  templateUrl: './help-video-player-dialog.component.html',
  styleUrl: './help-video-player-dialog.component.scss',
})
export class HelpVideoPlayerDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<HelpVideoPlayerDialogComponent>);
  readonly data = inject<HelpVideoPlayerData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }

  // Only clicks that land on the backdrop itself, not ones bubbling up from the player
  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) this.close();
  }
}
